import React, { useEffect, useState } from "react";

const messages = [
  "Loading tunnel",
  "Looking for data packets",
  "Analyzing",
  "Almost done",
  "Happy Hacking !",
];

const Preloader = () => {
  const [step, setStep] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const fadeInterval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setStep((prev) => (prev < messages.length - 1 ? prev + 1 : prev));
        setFade(true);
      }, 500); // fade-out duration
    }, 2000); // time between steps

    return () => clearInterval(fadeInterval);
  }, []);

  return (
    <div className="fixed inset-0 bg-slate-950 flex flex-col items-center justify-center text-center z-[9999] px-4">
      {/* Tunnel Spinner */}
      <svg
        className="w-32 h-32 animate-spin-slow mb-8 text-white opacity-50"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8z"
        ></path>
      </svg>

      {/* Message */}
      <div
        className={`transition-opacity duration-500 ease-in-out text-xl sm:text-2xl md:text-3xl font-semibold tracking-wide text-blue-600 [text-shadow:0_0_8px_rgba(59,130,246,0.8),0_0_16px_rgba(59,130,246,0.6)] ${
          fade ? "opacity-100" : "opacity-0"
        }`}
      >
        {messages[step]}<span className="animate-blink">_</span>
        <style>
        {`
            @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0; }
            }
            .animate-blink {
            animation: blink 0.2s step-start infinite;
            }
        `}
        </style>
      </div>
    </div>
  );
};

export default Preloader;
